module.exports = __webpack_public_path__ + "img/IMG_3450_L_Wood.b77a7112.jpg";